import { Search, FileCheck, FileCode, Edit, Box } from "lucide-react";

export const services = [
  {
    id: "discovery",
    title: "Discover Data Providers",
    description:
      "Discover business partners and AAS endpoints through an integrated AAS client, also available as an API.",
    link: "https://discovery.adx-hub.com/",
    icon: Search,
    iconImage: "/static/css/assets/img/icon_lupe_server_rgb_A.png",
    color: "#0028CD",
    remoteName: "discovery",
    remoteModule: "./App",
  },
  {
    id: "aas-viewer",
    title: "Discover AAS",
    description: "Explore discovered AAS records in list and detail workflows.",
    link: "#",
    icon: Box,
    iconImage: "/static/css/assets/img/discovery.png",
    color: "#0028CD",
    remoteName: "aas-viewer",
    remoteModule: "./AASViewer",
  },
  {
    id: "validation",
    title: "Validation Service",
    description: "Validate AAS files, submodels, and APIs against IDTA profiles, with API-based integration support.",
    link: "https://validation.adx-hub.com/",
    icon: FileCheck,
    iconImage: "/static/css/assets/img/icon_blue_3_aas_validation_service.png",
    color: "#0028CD",
    remoteName: "validation",
    remoteModule: "./App",
  },
  {
    id: "smt",
    title: "SMT Repository",
    description: "Fetch IDTA submodel templates across versions with advanced search, AASX/JSON download, and specification PDFs.",
    link: "https://smt-repo.admin-shell-io.com/",
    icon: FileCode,
    iconImage: "/static/css/assets/img/icon_blue_3_submodel_template_repository.png",
    color: "#0028CD",
    remoteName: "smt",
    remoteModule: "./App",
  },
  {
    id: "editor",
    title: "AAS Editor",
    description: "Easy onboarding and guided use-case workflows to create, edit, and deploy AAS.",
    link: "https://aas-editor.adx-hub.com/",
    icon: Edit,
    iconImage: "/static/css/assets/img/editor.png",
    color: "#0028CD",
    remoteName: "editor",
    remoteModule: "./App",
  },
];
